<template>
  <div class="home">

    <div class="d-none d-sm-none d-md-block">
      <Banners :banners="data_home_page.banners"></Banners>
    </div>

    <div class="d-block d-sm-block d-md-none">
      <CarouselMobile
        :show_search="true"
        :banners="data_home_page.banners"
        :show_user="true"
      ></CarouselMobile>
    </div>

    <div class="d-block d-sm-block d-md-none">
      <div class="container">
        <div class="row">
          <div class="col-7">
            <DeliveryOption></DeliveryOption>
          </div>
          <div class="col-5 d-flex justify-content-end">
            <div class="text-right">
              <v-btn
                v-if="!user.subscription && data_home_page.enabled_subscriptions"
                color="primary"
                class="btn-subscription"
                dark
                to="/suscripciones"
              >
                MEMBRESÍA
              </v-btn>
              <campaign-button
                :class="`${!user.subscription ? 'mt-2' : ''}`"
                link="/dilo-con-nieve"
                campaign_name="#DiloConNieve"
                v-if="data_home_page.on_dcn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Flavors
      :categories_flavors="data_home_page.categories_flavors"
      :show_buttons="true"
      :show_text="true"
    ></Flavors>

    <Instagram></Instagram>

    <div class="d-block d-sm-block d-md-none">
      <div class="px-5 mt-8 color-blue font-general-r">
        <h5>SUCURSAL</h5>
        <v-row class="text-mobile-sucursal align-items-center">
          <v-col cols="7" sm="7">
            <p class="mb-5">
              Alfonso Reyes 122,<br>
              Hipódromo Condesa, CDMX
            </p>
            <span>hola@nievedeolla.com</span><br>
            <span>+5527480380</span>
          </v-col>
          <v-col cols="5" sm="5" class="d-flex justify-content-end">
            <img class="icon-offices" src="@/assets/store/sucursal/sucursal.png" alt="">
          </v-col>
        </v-row>
      </div>
    </div>

    <v-snackbar
      v-model="message_new_user"
      color="secondary"
      bottom
      right
      multi-line
      timeout="8000"
    >
      <h5 class="font-general-r">
        ¡Bienvenido a Nieve de Olla, estamos <br> encantados que formes parte de nosotros!
      </h5>

    </v-snackbar>

    <v-dialog
      v-model="success_payment"
      persistent
      max-width="690"
    >
      <v-card class="pa-2">
        <v-card-text>

          <div class="d-flex justify-content-center align-items-center mt-10 color-blue font-general-r">
            <img style="width: 15%; max-width: 150px; max-height: 150px" class="mr-10 d-none d-sm-none d-md-block" src="@/assets/store/iconos/bolsa.svg" alt="">
            <div class="text-center">
              <h3>Gracias!</h3>
              <h5>Tu compra ha sido procesada exitosamente</h5>
              <h5>Te llegará un email con los detalles de entrega</h5>
              <span class="h5">Esperamos que vuelvas pronto</span>
            </div>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevation="0"
            class="nv-btn nv-btn-medium"
            @click="successOrderMercadoPago()"
          >
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PopupMessage
      ref="popupMessage"
      :message="message"
    />

  </div>
</template>

<script>
import Banners from '@/components/store/Banners'
import Instagram from '@/components/store/Instagram'
import Flavors from '@/components/store/Flavors'
import PaymentService from '@/services/payment.service'
import { mapState, mapGetters } from 'vuex'
import DeliveryOption from '@/components/store/mobile/DeliveryOption'
import CarouselMobile from '@/components/store/mobile/CarouselMobile'
import CampaignButton from '@/components/store/CampaignButton.vue'

export default {
  name: 'Home',
  components: {
    Banners,
    Instagram,
    Flavors,
    DeliveryOption,
    CarouselMobile,
    CampaignButton
  },
  data:() => ({
    dialog_init: false,
    url_banners_mobile: process.env.VUE_APP_URL_FILES,
    message_new_user: false,
    success_payment: false,
    message: '',
    items: [
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me 2' },
    ],
  }),
  computed: {
    ...mapState(['campaign_order', 'user', 'is_auth', 'cart', 'data_home_page', 'current_month']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    successOrderMercadoPago() {
      localStorage.removeItem('campaign_order')
      this.$store.dispatch('setPackageOrder', null)
      this.$router.push('/confirmacion-compra')
    },
    paymentMercadoPago(data_post) {
      this.dialog_init = true
      setTimeout(async () => {
        let order = JSON.parse(localStorage.getItem('order_temporal'))

        data_post.order = order
        data_post.comments = order.comments

        let route = ''
        if (this.is_auth) {
          route = 'payment-mp'
        } else {
          route = 'quick-payment-mp'
        }

        const { data:res } = await PaymentService.paymentMercadoPago(data_post, route)
        if (res.success) {
          this.success_payment = true
          setTimeout(() => {
            this.successOrderMercadoPago()
          }, 5000)
        } else {
          this.$swal(res.error, '', 'warning')
        }

      }, 1500)
    }
  },
  mounted() {

    if (this.$route.query.register && this.$route.query.user) {
      if (this.$route.query.register == 'success' && this.$route.query.user == 'new') {
        this.message_new_user = true
      }
    } else {
      this.message_new_user = false
    }

    if (this.$route.query.pay) {
      let status = this.$route.query.status
      console.log(status)
      if (status == 'approved' || status == 'in_process') {
        let data_post = {
          payment_status: status,
          paymentID: this.$route.query.payment_id,
          discount_id: this.$route.query.dis == 'n' ? false : this.$route.query.dis,
        }

        this.paymentMercadoPago(data_post)
      } else {
        this.$swal('Ha ocurrido un error al procesar el pago, intenta de nuevoo', '', 'warning')
      }
    }

    if (this.$route.query.exs) {
      this.message = '¡No puedes hacer una nueva suscripción porque ya posees una suscripción activa!'
      this.$refs.popupMessage.openDialog()
    }

  }
}
</script>
